import { StyleProvider } from "@ant-design/cssinjs";
import { QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider, type ThemeConfig } from "antd";
import ptBR from "antd/locale/pt_BR";
import { useSistemaStore } from "features/sistema/store";
import { setColors } from "features/sistema/util";
import { useServiceVersion } from "hooks/useServiceVerion";
import { lazy, Suspense, useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Router, router } from "router/Router";
import { useEffectOnce } from "std/hooks/useEffectOnce";
import { queryClient } from "./queryClient";

const TanStackRouterDevtools =
	process.env.NODE_ENV === "production"
		? () => null
		: lazy(() =>
				import("@tanstack/router-devtools").then((res) => ({
					default: res.TanStackRouterDevtools,
				})),
			);

const ReactQueryDevtools =
	process.env.NODE_ENV === "production"
		? () => null
		: lazy(() =>
				import("@tanstack/react-query-devtools").then((res) => ({
					default: res.ReactQueryDevtools,
				})),
			);

export function App() {
	const downloadSistema = useSistemaStore((s) => s.downloadSistema);
	const sistema = useSistemaStore((s) => s.sistema);

	const [theme, setTheme] = useState<ThemeConfig>();

	useServiceVersion(); // 👈 verifica se há atualização

	useEffect(() => {
		if (!sistema) {
			return;
		}

		// changeFavIcon(sistema.sis_logotipo || '');
		// changeManifestImgs(sistema.sis_nome_sistema);
		setColors(sistema.layout);

		setTheme({
			token: {
				colorPrimary: sistema.layout.sic_cor_primaria,
				fontFamily: "mukta",
			},
			components: {
				Breadcrumb: {
					colorText: sistema.layout.sic_menu_titulo,
				},
				Button: {
					colorTextLightSolid: sistema.layout.sic_botao_texto,
				},
				Switch: {
					colorTextLightSolid: sistema.layout.sic_botao_texto,
				},
			},
		});
	}, [sistema]);

	useEffectOnce(() => {
		downloadSistema();
	});

	return (
		<HelmetProvider>
			<QueryClientProvider client={queryClient}>
				<StyleProvider hashPriority="high">
					<ConfigProvider theme={theme} locale={ptBR}>
						<AntApp>
							<Router />
						</AntApp>
					</ConfigProvider>
				</StyleProvider>

				<Suspense fallback={null}>
					<TanStackRouterDevtools router={router} position="bottom-right" />
					<ReactQueryDevtools />
				</Suspense>
			</QueryClientProvider>
		</HelmetProvider>
	);
}
